import { render } from "./ZiList.vue?vue&type=template&id=53701a72&scoped=true"
import script from "./ZiList.vue?vue&type=script&lang=js"
export * from "./ZiList.vue?vue&type=script&lang=js"

import "./ZiList.vue?vue&type=style&index=0&id=53701a72&scoped=true&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53701a72"]])

export default __exports__